import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginType } from '../../classes/static/enums';
import { Extensions } from '../../classes/static/extensions';
import { LoginService } from '../../services/login.service';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'switch-login-transition-modal',
	template: require('./switch-login-transition-modal.component.html'),
})
export class SwitchLoginTransitionModalComponent implements OnInit {
	@Input() public loginType: LoginType;
	public title: string = '';
	public text: string = '';
	public image: string = '';
	public isRebrading = AppSettings.isRebrading;
	constructor(
		private activeModal: NgbActiveModal,
		private route: ActivatedRoute,
		private _router: Router
	) {}

	public ngOnInit() {
		if (this.loginType == LoginType.Corporate) {
			this.title = 'Μεταφορά στο i-bank ιδιωτών';
			this.image = './Content/images/blocked-business.svg';
			this.text =
				'Επιχειρήσατε είσοδο μέσω της σελίδας i-bank επιχειρήσεων, σας μεταφέρουμε στο i-bank ιδιωτών για να εισέλθετε στο λογαριασμό σας.';
		} else if (this.loginType == LoginType.Retail) {
			this.title = 'Μεταφορά στο i-bank επιχειρήσεων';
			this.image = './Content/images/blocked-retail.png';
			this.text =
				'Επιχειρήσατε είσοδο μέσω της σελίδας i-bank ιδιωτών, σας μεταφέρουμε στο i-bank επιχειρήσεων για να εισέλθετε στο λογαριασμό σας.';
		}
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public transfer(): void {
		if (this.loginType == LoginType.Corporate) {
			this.selectRetail();
		} else if (this.loginType == LoginType.Retail) {
			this.selectCorporate();
		}
		this.activeModal.close(true);
	}

	private selectRetail() {
		Extensions.setSelectedLoginType(this._router, this.route, LoginType.Retail);
	}

	private selectCorporate() {
		Extensions.setSelectedLoginType(this._router, this.route, LoginType.Corporate);
	}
}
